// Constants for different requests for current reducer
export default {
  infoNote: 'INFO_NOTE',
};

export const InfoNoteTypes = {
  SINGLE_SITE: 'SINGLE_SITE',
  MULTIPLE_SITES: 'MULTIPLE_SITES',
};
